export default [
    // *========come===========Bank List============================---*
    {
        path: '/reconciliation/:id',
            name: 'reconciliation',
            component: () => import('@/views/accounting/Reconciliation/reconciliation.vue'),
            meta: {
                pageTitle: 'Reconciliation',
                breadcrumb: [
                    {
                        text: 'Reconciliation',
                        active: true,
                    },
                ],
                //permission: 'Permissions.Accounting.View'            
            },
    },
    {
        path: '/reconciliation/view/:id',
            name: 'reconciliationView',
            component: () => import('@/views/accounting/Reconciliation/view.vue'),
            meta: {
                pageTitle: 'Reconciliation-View',
                breadcrumb: [
                    {
                        text: 'Reconciliation/view',
                        active: true,
                    },
                ],
                //permission: 'Permissions.Accounting.View'            
            },
    }
    ]